import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { aoExpirarSessao } from '@/api/sessao-expirada';
import { limparSessao } from '@/auth/session-store';

/**
 * Ouve `anunciarSessaoExpirada()` (disparado por `@/api/turbopro` quando um
 * 401 não consegue ser renovado) e leva ao login — em vez de cada tela
 * degradar do seu jeito com um 401 solto (esqueleto eterno, "não foi possível
 * carregar" etc.), sem explicar ao usuário que só precisava entrar de novo.
 */
export function SessaoExpiradaDialog() {
  const [aberto, setAberto] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => aoExpirarSessao(() => setAberto(true)), []);

  const handleConfirmar = () => {
    setAberto(false);
    limparSessao();
    queryClient.clear();
    navigate('/login');
  };

  return (
    <Dialog open={aberto}>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={e => e.preventDefault()}
        onPointerDownOutside={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Sessão expirada</DialogTitle>
          <DialogDescription>
            Sua sessão expirou por inatividade. Entre novamente para continuar.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleConfirmar}>Ir para o login</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
